import { Play } from 'lucide-react'
import { cn } from '@/lib/utils'

/** `youtube-nocookie` não planta cookie de rastreio antes de o vídeo tocar. */
export function embedSrc(id: string): string {
  return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`
}

/**
 * A capa. `hqdefault` e não `maxresdefault`: o segundo dá 404 em vídeo que não
 * foi enviado em alta, e o 404 aparece como buraco na vitrine.
 */
export function coverSrc(id: string): string {
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`
}

/**
 * Um vídeo do YouTube na página pública de um criador: capa até o clique,
 * player depois dele.
 *
 * Nenhum iframe nasce com a página — mesma regra do SurfShorts, e pelo mesmo
 * motivo: um embed do YouTube passa de 1 MB e seria a coisa mais cara da
 * landing. O que carrega é uma imagem; o player entra quando alguém quer ver.
 *
 * Quem controla o que está tocando é o pai (`playing` + `onPlay`): dois
 * players tocando juntos viram dois áudios sobrepostos, e quem clicou no
 * segundo não faz ideia de onde vem o primeiro.
 */
export default function VideoDoCriador({
  id,
  title,
  playing,
  onPlay,
  className,
}: {
  id: string
  /** Vira o `alt` da capa, o rótulo do botão e o `title` do iframe. */
  title: string
  playing: boolean
  onPlay: () => void
  className?: string
}) {
  return (
    <div className={cn('relative h-full w-full overflow-hidden', className)}>
      {playing ? (
        <iframe
          src={embedSrc(id)}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="h-full w-full border-0"
        />
      ) : (
        <button
          type="button"
          onClick={onPlay}
          aria-label={`Assistir: ${title}`}
          className="group relative block h-full w-full"
        >
          <img
            src={coverSrc(id)}
            alt={title}
            loading="lazy"
            className="h-full w-full object-cover"
          />
          {/* A tarja escura é o que garante contraste do play sobre capa
              clara — sem ela, vídeo com fundo de areia some o botão. */}
          <span className="absolute inset-0 bg-black/20 transition-colors group-hover:bg-black/30" />
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="flex size-14 items-center justify-center rounded-full bg-white/95 shadow-lg transition-transform group-hover:scale-105">
              <Play
                aria-hidden="true"
                className="ml-0.5 size-6 fill-gray-900 text-gray-900"
              />
            </span>
          </span>
        </button>
      )}
    </div>
  )
}
